import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { SvbrgExtractSupplierRequestInput, SvbrgExtractSupplierRequestOutput } from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

export const ExtractSupplierRequestTool: ToolResultComponent<
  Tool.extractSupplierRequest,
  SvbrgExtractSupplierRequestInput,
  SvbrgExtractSupplierRequestOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return (
        <ChatLoadingIndicator
          message={t('call', {
            count: tool.input?.fileIds.length ?? 0,
          })}
        />
      );

    case 'output-available':
      return (
        <ChatToolResultIndicator
          // safeguard with "|| 0" in case of unexpected null values
          // this would mean tool schema output failed - left over for safety
          message={t('result', {
            lineItems: tool.output.allLineItems.length || 0,
            documents: tool.output.documents.length || 0,
          })}
        />
      );
  }
};
